/**
 * Button variants — colour intent only. Sizes are a separate axis. Variants
 * mirror the prototype's `.btn--filled`/`--tonal`/`--outlined`/`--text`/
 * `--danger`/`--success` modifiers so the design vocabulary maps 1:1.
 */
export const BUTTON_VARIANT_FILLED = 'filled';
export const BUTTON_VARIANT_TONAL = 'tonal';
export const BUTTON_VARIANT_OUTLINED = 'outlined';
export const BUTTON_VARIANT_TEXT = 'text';
export const BUTTON_VARIANT_DANGER = 'danger';
export const BUTTON_VARIANT_SUCCESS = 'success';

export type ButtonVariant =
  | typeof BUTTON_VARIANT_FILLED
  | typeof BUTTON_VARIANT_TONAL
  | typeof BUTTON_VARIANT_OUTLINED
  | typeof BUTTON_VARIANT_TEXT
  | typeof BUTTON_VARIANT_DANGER
  | typeof BUTTON_VARIANT_SUCCESS;

export const BUTTON_SIZE_SM = 'sm';
export const BUTTON_SIZE_MD = 'md';
export const BUTTON_SIZE_LG = 'lg';

export type ButtonSize =
  | typeof BUTTON_SIZE_SM
  | typeof BUTTON_SIZE_MD
  | typeof BUTTON_SIZE_LG;

/**
 * Per-size pill height + horizontal padding + label font size, matching the
 * `.btn`, `.btn--sm`, `.btn--lg` rules in the design's `styles.css`. Kept
 * here (not in the styled file) so the component file and its tests can
 * import the exact values without round-tripping through CSS.
 */
export const BUTTON_SIZE_TOKENS: Record<
  ButtonSize,
  { height: string; padX: string; fontSize: string; iconSize: string }
> = {
  [BUTTON_SIZE_SM]: { height: '30px', padX: '12px', fontSize: '12.5px', iconSize: '16px' },
  [BUTTON_SIZE_MD]: { height: '36px', padX: '16px', fontSize: '13.5px', iconSize: '18px' },
  [BUTTON_SIZE_LG]: { height: '44px', padX: '24px', fontSize: '14px', iconSize: '20px' },
};
